/* import __COLOCATED_TEMPLATE__ from './seller-network-module.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';

const CLASS_NAME = 'SH-c-seller-network-module';

class SellerNetworkModuleComponent extends Component {
  @service session;

  @tracked selectedCompanyConnection = this.args.inNetworkCompanyConnections?.[0] ?? null;

  get className() {
    return CLASS_NAME;
  }

  get dropdownOptions() {
    return this.args.inNetworkCompanyConnections.reduce((accum, connection) => {
      accum.push({
        title: connection.company.name,
        value: connection.id,
        selected: this.selectedCompanyConnection.id === connection.id,
      });

      return accum;
    }, []);
  }

  get title() {
    return this.args.inNetworkCompanyConnections?.length ? `My Networks (${this.args.inNetworkCompanyConnections.length})` : 'My Networks';
  }

  @action
  setDropdownValue(newValue) {
    this.selectedCompanyConnection = this.args.inNetworkCompanyConnections.find(connection => connection.id === newValue);
  }
}

export default SellerNetworkModuleComponent;
